import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import {
    checkboxListValueTypes,
    extendedStateType,
} from '../../../types';
import CheckboxList from '../CheckboxList';
import ReadonlyList from '../ReadonlyList';
import { NO_STATE } from '../../../hooks/useExtendedState';
import { resolveValue } from '../../../utils/fields';

PrivilegedCheckboxList.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    values: checkboxListValueTypes.isRequired,
    selectedValues: PropTypes.arrayOf(PropTypes.string),
    state: extendedStateType,
};

PrivilegedCheckboxList.defaultProps = {
    sufficientReadPrivileges: null,
    selectedValues: undefined,
    state: NO_STATE,
};

function PrivilegedCheckboxList(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        selectedValues,
        values,
        state,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const resolvedSelectedValues = resolveValue(selectedValues, state) || [];
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <CheckboxList
                    selectedValues={selectedValues}
                    values={values}
                    state={state}
                    {...rest}
                />
            )
            : (
                canRead && (
                    <ReadonlyList
                        values={resolvedSelectedValues.map((selectedValue) => values.find((value) => value.id === selectedValue).label)}
                        state={state}
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedCheckboxList;
